"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Level1EventName = void 0;
var Level1EventName;
(function (Level1EventName) {
    Level1EventName["PLACE_THING_INTO_NON_LIVING"] = "placeThingIntoNonLiving";
    Level1EventName["PLACE_THING_INTO_LIVING"] = "placeThingIntoLiving";
    Level1EventName["GUESS_ANSWER"] = "guessAnswer";
})(Level1EventName = exports.Level1EventName || (exports.Level1EventName = {}));
//# sourceMappingURL=Level1EventName.js.map